<script setup lang='ts'>
import type { ComplaintFeedback } from '../hooks/complaint'

// import ComplaintFeedBack from './ComplaintFeedBack.vue'
import { USER_TYPE_CODE } from '~/shared/constants'

const props = withDefaults(defineProps<{
  isChild?: boolean
  parentIndex?: number
  isComment?: boolean
  list?: ComplaintFeedback[] | ComplaintFeedback['replyList']
}>(), {
  isChild: false,
  parentIndex: -1,
  isComment: false,
  list: () => [],
})

function getUserTypeCodeIndex(code: string): number {
  if (!code)
    return 1
  const index = Object.keys(USER_TYPE_CODE).findIndex(v => v === code)
  return index === -1 ? 0 : index
}
</script>

<template>
  <div>
    <div
      v-for="(item, index) in props.list" :key="index"
      class="flex border-b-1 border-slate-2 last:b-0 pt-4"
    >
      <div class="mr-4 flex-shrink-0 rounded-full w-12 h-12 grid place-content-center text-white" :class="[`type-${getUserTypeCodeIndex(item.userTypeCode)}`]">
        {{ USER_TYPE_CODE[item.userTypeCode] }}
      </div>
      <div class="flex-grow min-w-0 overflow-hidden">
        <div class="text-info mb-2 text-3.5">
          {{ item.createTime }}
        </div>
        <div class="pb-4 flex items-start">
          <div v-if="props.isChild" class="mr-1.25 text-info flex-shrink-0">
            回复:
          </div>
          <div class="flex-grow min-w-0 overflow-hidden flex justify-between items-end">
            <div class="mr-6">
              {{ item.feedbackContent }}
            </div>
          </div>
        </div>
        <!-- reply -->
        <div v-if="!props.isChild && (item as ComplaintFeedback).replyList?.length" class="public-border-top">
          <ComplaintFeedBack :is-child="true" :list="(item as ComplaintFeedback).replyList" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.type {
  &-0 {
    background-color: #488bfa;
    font-weight: bold;
  }
  &-1 {
    background-color: #ec1313;
    font-weight: bold;
  }
  &-2 {
    background-color: #ff551d;
    font-weight: bold;
  }
}
</style>
